import "./SecureClientUpload.module.css";
import Mainheader from "@/pages/Home/sections/Mainheader";
import Footer from "@/reusable_sections/Footer";
import SecureUpload from "./sections/SecureUpload";
export default function SecureClientUploadPage() {
  return <div>
      <Mainheader />
      <SecureUpload />
      <Footer />
    </div>;
}